export const chapterMap = {
  intake: { num: '01', code: 'INT', name: 'INTAKE', left: 'Listen · Type', right: 'Grounded · Repo' },
  index: { num: '02', code: 'IDX', name: 'INDEX', left: 'Repo · Scan', right: 'Context · Files' },
  draft: { num: '03', code: 'DRF', name: 'DRAFT', left: 'Review · Edit', right: 'Approve · Ship' },
  ship: { num: '04', code: 'SHP', name: 'SHIP', left: 'Published', right: 'Jira · Asana · Live' },
}

export const defaultSuggestions = [
  'split checkout into payment + order services',
  'bug: cart total ignores tax with promo',
  'rate-limit the public API gateway',
]

export const PANEL_TYPES = ['landing', 'auth', 'draft', 'integrations', 'billing', 'tickets', 'oauth', 'sensitive']
